module.exports = __webpack_public_path__ + "static/img/水位预警识别.ea3d7a59.png";